module.exports = __webpack_public_path__ + "img/home_top3.9faf461c.png";